import React, { useState } from "react";
import Intro from "./components/Intro";
import Quiz from "./components/Quiz";
import "./QuizApp.css";

export default function QuizApp() {
  const [quizStarted, setQuizStarted] = useState(false);
  const [questionsCount, setQuestionsCount] = useState(10);

  if (!quizStarted) {
    return (
      <Intro
        startQuiz={(questions: string) => {
          setQuestionsCount(parseInt(questions));
          setQuizStarted(true);
        }}
      />
    );
  }

  return (
    <Quiz
      questionsCount={questionsCount}
      stopQuiz={() => {
        setQuizStarted(false);
      }}
    />
  );
}
